import EFTB from '@images/etiqa logo/EFTB-MY.png';
import ELIB from '@images/etiqa logo/ELIB-MY.png';

export default {
  takafulTitle: 'i-MedicalCard Elite',
  insuranceTitle: 'EzyMedical',
  gabTitle: 'EasyHealth First',
  logo: {
    takaful: EFTB,
    insurance: ELIB,
  },
};
